(() => {
  function select(btn) {
    const card = btn.closest('[data-card]');
    if (!card || btn.getAttribute('aria-pressed') === 'true') return;
    const target = btn.dataset.swatch;
    card.querySelectorAll('[data-color-img]').forEach(el => el.classList.toggle('is-active', el.dataset.colorImg === target));
    card.querySelectorAll('[data-swatch]').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
    if (btn.dataset.variant) {
      card.querySelectorAll('a[data-card-link]').forEach(a => {
        const url = new URL(a.getAttribute('href'), location.origin);
        url.searchParams.set('variant', btn.dataset.variant);
        a.setAttribute('href', url.pathname + url.search);
      });
    }
  }
  document.addEventListener('click', e => {
    const btn = e.target.closest('button[data-swatch]');
    if (!btn) return;
    e.preventDefault();
    select(btn);
  });
  document.addEventListener('pointerover', e => {
    if (e.pointerType !== 'mouse') return;
    const btn = e.target.closest('button[data-swatch]');
    if (btn) select(btn);
  });
})();
